import type { ScenarioAttributeNode } from '../../../features/scenarios/api';
import type { HierarchicalOption } from '../../common/HierarchicalSelect';

// シナリオ全体の方言 (属性ツリー scenario_basic > dialect > option)。選択肢と指示本文は DB が正本。
// 空文字は指定なし (プロンプト追記なし)。option の metadata.voice_accent は Gemini の
// 拡張ボイスライブラリの accent 値 (API の生値) で、ナレーターの地域絞り込みに使う。
export const DIALECT_FIELD_KEY = 'dialect';

export function normalizeDialect(values?: Record<string, unknown> | null): string {
  const raw = values?.dialect;
  const key = typeof raw === 'string' ? raw.trim() : '';
  return key === 'none' ? '' : key;
}

export function deriveDialectOptions(items?: ScenarioAttributeNode[]) {
  const find = (nodes: ScenarioAttributeNode[]): ScenarioAttributeNode | undefined => {
    for (const node of nodes) {
      if (node.key === DIALECT_FIELD_KEY && node.node_type === 'group') return node;
      const found = find(node.children ?? []);
      if (found) return found;
    }
  };
  const field = find(items ?? []);
  const voiceAccents: Record<string, string> = {};
  const toOptions = (nodes: ScenarioAttributeNode[]): HierarchicalOption[] =>
    nodes.flatMap((node): HierarchicalOption[] => {
      if (node.node_type === 'group') {
        const children = toOptions(node.children ?? []);
        return children.length ? [{ id: node.id, key: node.key, label: node.label, type: 'group', children }] : [];
      }
      if (node.node_type !== 'option') return [];
      const accent = node.metadata?.voice_accent;
      if (typeof accent === 'string' && accent.trim()) voiceAccents[node.key] = accent.trim();
      return [{ id: node.id, key: node.key, label: node.label, type: 'option' }];
    });
  const dialectOptions = toOptions(field?.children ?? []);
  return {
    dialectOptions,
    dialectFieldPlacement: (field?.placement === 'primary' ? 'primary' : 'advanced') as 'primary' | 'advanced',
    // option key → ナレーターの accent (API の生値)。voice_accent の無い方言は含めない
    dialectVoiceAccents: voiceAccents,
  };
}
